import { createVanIconComponent } from "./van"

const QrInvalid = createVanIconComponent("qr-invalid")
export default QrInvalid
